import { BillingModel } from '@/modules/billing/entities/billing.enums';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

export class BillingService extends HttpClientAdapter {
  constructor() {
    super('NEGOTIATION');
  }

  async getBillingModel(companyId: string) {
    const { isEligible } = await this.get<FeeForLifeEligibility>(`/companies/${companyId}/fee-for-life-eligibility`);

    return {
      model: isEligible ? BillingModel.FEE_FOR_LIFE : BillingModel.FEE_FOR_SERVICE
    };
  }
}

export interface FeeForLifeEligibility {
  isEligible: boolean;
}
